/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-console */
import React, { Component } from "react";
import Grid from "../../../../components/Grid";
import { ColumnType } from "../../../../components/Grid/constants";
import localProvider, {
  Order,
} from "../../../../components/Grid/localProvider";
import { compareArrayLength } from "../../CroUtils";
import { getFile, postFile } from "../../CroActions";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_FILE_ACCEPT,
} from "../generalForm/CroFileUpload";
import { noop } from "lodash";

class FilesGrid extends Component {
  static defaultProps = {
    filtering: false,
    adding: false,
    deleting: false,
    uploadMode: "grid",
    onFileAdded: noop,
    onRemove: noop,
  };

  state = {
    error: "",
    isDragOver: false,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.url !== this.props.url ||
      compareArrayLength(nextProps.items, this.props.items) ||
      this.state.error !== nextState.error ||
      this.state.isDragOver !== nextState.isDragOver ||
      nextProps.adding !== this.props.adding ||
      nextProps.uploadMode !== this.props.uploadMode
    );
  }

  onFileAddClick = () => {
    if (this.fileInput) {
      this.fileInput.click();
    }
  };

  uploadFile = async (file) => {
    const { dispatch } = this.props;
    if (!file) return;

    const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
    if (!ALLOWED_FILE_EXTENSIONS.includes(ext)) {
      this.setState({
        error: `Nepodporovaný formát souboru. Povolené formáty: ${ALLOWED_FILE_EXTENSIONS.join(", ")}`,
      });
      return;
    }

    if (file.size > 10000000) {
      this.setState({
        error: "Soubor je příliš velký. Maximální velikost je 10 MB.",
      });
      return;
    }

    this.setState({ error: "" });
    const fileRef = await postFile(file, "/api/files/", dispatch);
    this.props.onFileAdded(fileRef);
  };

  onFileChange = async (e) => {
    const file = e && e.target && e.target.files ? e.target.files[0] : null;
    await this.uploadFile(file);
    if (e && e.target) {
      e.target.value = "";
    }
  };

  onDragOver = (e) => {
    e.preventDefault();
    if (this.props.adding && !this.state.isDragOver) {
      this.setState({ isDragOver: true });
    }
  };

  onDragLeave = (e) => {
    e.preventDefault();
    if (this.state.isDragOver) {
      this.setState({ isDragOver: false });
    }
  };

  onDrop = async (e) => {
    e.preventDefault();
    if (!this.props.adding) return;

    this.setState({ isDragOver: false });
    const files = e.dataTransfer && e.dataTransfer.files;
    if (files && files[0]) {
      await this.uploadFile(files[0]);
    }
  };

  onRowClick = (fileRef) => getFile(fileRef.id);

  render() {
    const {
      onRemove,
      adding,
      filtering,
      deleting,
      items,
      gridName,
      uploadMode,
    } = this.props;

    const props = {
      columns: [
        {
          field: "name",
          label: "Soubor",
          type: ColumnType.TEXT,
          width: "70%",
        },
        {
          field: "created",
          label: "Vytvořen",
          type: ColumnType.DATE,
          width: "30%",
        },
      ],
      filtering,
      onAdd: this.onFileAddClick,
      adding,
      deleting,
      onRemove,
      addButtonStyle: { color: "white", marginRight: 10 },
      editing: false,
    };

    const ConnectedGrid = localProvider(
      gridName,
      { items, sort: "created", order: Order.DESC, pageSize: 1000 },
      Grid,
    );

    const dropzoneClassName = [
      "filesGrid__dropzone",
      this.state.isDragOver ? "filesGrid__dropzone--active" : "",
      !adding ? "filesGrid__dropzone--disabled" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div
        className={
          uploadMode === "dropzone"
            ? "filesGrid filesGrid--dropzone"
            : "filesGrid"
        }
      >
        {this.state.error ? (
          <div className="error">{this.state.error}</div>
        ) : null}
        <input
          type="file"
          style={{ display: "none" }}
          ref={(node) => (this.fileInput = node)}
          onChange={this.onFileChange}
          accept={ALLOWED_FILE_ACCEPT}
        />

        {uploadMode === "dropzone" && adding ? (
          <div
            className={dropzoneClassName}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            onDrop={this.onDrop}
          >
            <div className="filesGrid__dropzoneText">
              Přetáhněte soubor nebo
            </div>
            <button
              type="button"
              className="filesGrid__dropzoneButton"
              onClick={this.onFileAddClick}
            >
              Nahrát ze zařízení
            </button>
            <div className="filesGrid__dropzoneHint">
              Podporované formáty PDF, DOC(X), XML, XLS(X), ODT, ODS, RTF, MSG, JPG, JPEG, PNG. Max. velikost 10 MB.
            </div>
          </div>
        ) : null}

        <ConnectedGrid
          onRowClick={this.onRowClick}
          rowStyle={{ cursor: "pointer" }}
          {...props}
          showPaging={false}
        />
      </div>
    );
  }
}

export default FilesGrid;
